import { Card } from "@/components/ui/card";
import { useQuoteForm } from "@/hooks/useQuoteForm";
import { submitQuote } from "@/utils/quoteSubmission";
import { isStepComplete } from "@/utils/quoteValidation";
import { InsuranceType } from "./quote/types";
import FormSteps from "./quote/FormSteps";
import FormNavigation from "./quote/FormNavigation";

const QuoteForm = () => {
  const {
    step,
    setStep,
    selectedType,
    setSelectedType,
    address,
    handleAddressChange,
    personalInfo,
    handlePersonalInfoChange,
    isSubmitting,
    setIsSubmitting,
    resetForm,
    toast
  } = useQuoteForm();

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleSubmit = async () => {
    if (!isStepComplete(step, selectedType, address, personalInfo)) return;
    if (!selectedType) return;
    
    setIsSubmitting(true);
    try {
      await submitQuote({
        selectedType,
        address,
        personalInfo
      });

      toast({
        title: "Quote submitted successfully!",
        description: "We'll get back to you soon.",
      });

      resetForm();
    } catch (error) {
      console.error('Error submitting quote:', error);
      toast({
        variant: "destructive",
        title: "Error submitting quote",
        description: "Please try again later.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleContinue = () => {
    if (step === 4) {
      handleSubmit();
    } else if (isStepComplete(step, selectedType, address, personalInfo)) {
      setStep(step + 1);
    }
  };

  return (
    <Card className="w-full max-w-2xl mx-auto p-8 shadow-lg animate-fade-up bg-white/50 backdrop-blur-sm border border-gray-100">
      <div className="space-y-8">
        <FormSteps
          step={step}
          selectedType={selectedType}
          address={address}
          personalInfo={personalInfo}
          onTypeChange={(value: InsuranceType) => setSelectedType(value)}
          onAddressChange={handleAddressChange}
          onPersonalInfoChange={handlePersonalInfoChange}
          onStepComplete={handleContinue}
        />
        <FormNavigation
          step={step}
          isSubmitting={isSubmitting}
          isStepValid={isStepComplete(step, selectedType, address, personalInfo)}
          onBack={handleBack}
          onContinue={handleContinue}
        />
      </div>
    </Card>
  );
};

export default QuoteForm;